import {
  TrainingRecord,
  TrainingRecordFormData,
  TrainingRecordQueryParams,
} from "../types"
import { ID, PaginationResult } from "@/types/common"
import { createCrudApi } from "@/utils/apiFactory"

const baseApi = createCrudApi<
  TrainingRecord,
  TrainingRecordFormData,
  TrainingRecordFormData
>("/training-records")

// 训练记录API
const trainingRecordApi = {
  // 查询所有
  async getList(
    params: TrainingRecordQueryParams
  ): Promise<PaginationResult<TrainingRecord>> {
    return baseApi.list({
      trainingPlanId: params.trainingPlanId,
      studentId: params.studentId,
      domainLv1Id: params.domainLv1Id,
      domainLv2Id: params.domainLv2Id,
      trainingProjectId: params.trainingProjectId,
      page: params.page,
      pageSize: params.pageSize,
    })
  },

  // ID查询
  async getById(id: ID): Promise<TrainingRecord | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: TrainingRecordFormData): Promise<void> {
    const payload = {
      trainingPlanId: data.trainingPlanId,
      assistTypeId: data.assistTypeId,
      trainingDate: data.trainingDate,
      userId: data.userId,
      ...(data.note && { note: data.note }),
    }
    await baseApi.create(payload)
  },

  // 更新
  async update(id: ID, data: TrainingRecordFormData): Promise<void> {
    const payload = {
      trainingPlanId: data.trainingPlanId,
      assistTypeId: data.assistTypeId,
      trainingDate: data.trainingDate,
      userId: data.userId,
      ...(data.note && { note: data.note }),
    }
    await baseApi.update(id, payload)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default trainingRecordApi
